import { useAuthenticatedSession, useSession } from "../../session";
import { PageHeader } from "../../shell";
import { MarqueFormulaires } from "./MarqueFormulaires";
import { ParametresOnglets } from "./ParametresOnglets";

/** La marque de l'entreprise, pour ses administrateurs. */
export function MarquePage() {
  const { company } = useAuthenticatedSession();
  const { setCompany } = useSession();
  if (company === null) {
    return null;
  }
  return (
    <>
      <PageHeader
        eyebrow="Paramètres"
        title="Marque"
        description="Le nom, le logo et la couleur que voient les membres de l'entreprise. La mise à jour est visible immédiatement dans la navigation."
      />
      <ParametresOnglets />
      <MarqueFormulaires company={company} onUpdated={setCompany} />
    </>
  );
}
